// import React, { useContext, useRef, useEffect, useState } from 'react'
// import { Link, useHistory } from 'react-router-dom'
// import { UserContext } from '../App'
// import "./../css/navbar.css"
// import 'bootstrap/dist/css/bootstrap.min.css';
// // import M from 'materialize-css'

// const NavBar = () => {
//   const searchModal = useRef(null)
//   const [search, setSearch] = useState('')
//   const [userDetails, setUserDetails] = useState([])
//   const { state, dispatch } = useContext(UserContext)
//   const history = useHistory()
//   useEffect(() => {
//     //  M.Modal.init(searchModal.current)
//   }, [])
//   const renderList = () => {
//     if (state) {
//       return [
//         <li key="1"><Link className="myNavbar-link" to="/create">Create Contact</Link></li>,
//         <li key="2"><Link to="/contacts">My Contact</Link></li>,
//         <li key="3">
//           <button className="btn #c62828 red darken-3"
//             onClick={() => {
//               localStorage.clear()
//               dispatch({ type: "CLEAR" })
//               history.push('/signin')
//             }}
//           >
//             Logout
//           </button>
//         </li>


//       ]
//     } else {
//       return [
//         <ul class="navbar-nav">
//                 <li key="4"class="nav-item">
//                 <Link to="/" className="nav-link" style={{color:"#fff"}}><span className="nav-link-text">Home</span></Link>
//                 </li>
//                 <li key="4"class="nav-item">
//               <Link to="/" className="nav-link" style={{color:"#fff"}}><span className="nav-link-text">Home</span></Link>
//               </li>
//               </ul>
        


//       ]
//     }
//   }
//   return(
//     <nav class="navbar navbar-expand-lg navbar-light bg-dark">
//             <Link to="/" className="navbar-brand" style={{color: "#F89A99"}}>Phone Pocket</Link>
            
//           {renderList()}
//         </nav>
//   )
// }


// export default NavBar


import React,{useContext,useRef,useEffect,useState} from 'react'
import {Link ,useHistory} from 'react-router-dom'
import {UserContext} from '../App'
import M from 'materialize-css'
import "./../css/navbar.css"

const NavBar = ()=>{
    const [userDetails,setUserDetails] = useState([])
     const {state,dispatch} = useContext(UserContext)
     const history = useHistory()
     useEffect(()=>{
        //  M.Modal.init(searchModal.current)
     },[])
     const renderList = ()=>{
       if(state){
           return [
            // <li key="1"><i  data-target="modal1" className="large material-icons modal-trigger" style={{color:"black"}}>search</i></li>,
            <li key="2"><Link to="/profile" style={{textDecoration:"none"}}>Profile</Link></li>,
            <li key="3"><Link to="/create" style={{textDecoration:"none"}}>New Contact</Link></li>,
            <li  key="5">
             <button className="btn #c62828 btn-primary btn-sm darken-3"
             style={{margin:" auto 12px auto 2px"}}
            onClick={()=>{
              localStorage.clear()
              dispatch({type:"CLEAR"})
              history.push('/signin')
            }}
            >
                Logout
            </button>
            </li>
         
            
           ]
       }else{
         return [
          <li  key="6"><Link to="/signin" style={{textDecoration:"none"}}>SignIn</Link></li>,
          <li  key="7"><Link to="/signup" style={{textDecoration:"none"}}>SignUp</Link></li>
         
         ]
       }
     }

    return(
        <nav>
        <div className="nav-wrapper" style={{backgroundColor:"#EEC1BC"}}>
          <Link to="/" className="brand-logo left mylogo"style={{marginLeft:"4.2%", textDecoration:"none"}} ><span style={{ color: "#2E357E"}}>PhonePocket</span></Link>
          <ul id="nav-mobile" className="right">
             {renderList()}
  
          </ul>
        </div>
      </nav>

      
    )
}


export default NavBar